import React, { useCallback, useEffect, useState } from 'react';
import {
  CardContent,
  DeleteIconBox,
  EditIconBox,
  FlexWrapper,
  HighlightText,
  ViewIconBox
} from '../../theme/common_style';
import { Button, Drawer, Select, Table } from 'antd';
import {
  ClientCardIcon1,
  ClientCardIcon2,
  ClientCardIcon3,
  ClientEmptyIcon,
  DeleteIcon,
  EditIcon,
  TrashIconNew,
  ViewIconNew
} from '../../theme/SvgIcons';
import Title from 'antd/es/typography/Title';
import { useDispatch, useSelector } from 'react-redux';
import { updateActivityDrawer } from '../../redux/sidebar/SidebarSlice';
import CountUp from 'react-countup';
import ConfirmationModal from '../../components/Modal/ConfirmationModal';
import EmptyData from '../../components/common/EmptyData';
import ActivityDrawer from './ActivityDrawer';
import SearchField from '../../components/searchField/SearchField';
import AddId from './AddId';
import {
  DeleteProjectSource,
  GetBillingIdCount,
  GetProjectSources
} from '../../redux/billingIds/apiRoute';
import { toast } from 'react-toastify';
import ViewBillingId from './ViewBillingId';
import { StickyBox } from '../../utils/style';
import {
  checkPermission,
  debounce,
  decryptToken,
  generateEmployeeImgUrl,
  getBillingTag,
  getFullName,
  hexToRgba,
  useWindowWide
} from '../../utils/common_functions';
import {
  actionTypeEnums,
  apiModules,
  Billing_ids_status_color,
  billingIdsStatus
} from '../../utils/constant';
import ProjectCard from '../../components/projects/ProjectCard';
import ProjectsListingModal from './ProjectsListingModal';
import styled from '@emotion/styled';
import { AvatarGroup } from '../../components/common/AvatarGroup';
import { PauseCircleOutlined } from '@ant-design/icons';

const BillingIds = () => {
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState(null);
  const activityDrawer = useSelector((state) => state?.sidebar?.isActivityDrawer);
  const [addModal, setAddModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [viewData, setViewData] = useState(false);
  const largeScreen = useWindowWide(1085);
  const mediumScreen = useWindowWide(600);
  const [view, setView] = useState(false);
  const { permissions, user_details } = useSelector((state) => state?.userInfo?.data);
  const { PSID } = apiModules;
  const { CREATE, UPDATE, DELETE } = actionTypeEnums;
  const canCreate = checkPermission(PSID, CREATE, permissions);
  const canUpdate = checkPermission(PSID, UPDATE, permissions);
  const canDelete = checkPermission(PSID, DELETE, permissions);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [status, setStatus] = useState(undefined);
  const [cardLoading, setCardLoading] = useState(true);
  const [projectList, setProjectList] = useState(false);
  const [projectListData, setProjectListData] = useState([]);
  const [sort, setSort] = useState({});

  const handleSorting = (val) => {
    if (val?.field) {
      let order = val?.order == 'ascend' ? 'ASC' : 'DESC';
      setSort({ sortBy: val?.field, orderBy: order, ...val });
    } else {
      setSort({});
    }
  };

  const BillingStatusTag = (status) => {
    const color = Billing_ids_status_color[status] || 'default';
    const formatted = status.replace(/[_-]/g, ' ').replace(/\b\w/g, (match) => match.toUpperCase());

    return (
      <Tag color={color} bg={hexToRgba(color)}>
        {formatted}
      </Tag>
    );
  };

  const billingStatData = [
    {
      icon: <ClientCardIcon1 />,
      bg: '#DDF3FF',
      label: 'Total Billing IDs',
      status: 'total',
      value: 0
    },
    {
      icon: <ClientCardIcon2 color="#52c41a" />,
      bg: '#52c41a47',
      label: 'Available IDs',
      status: 'available',
      value: 0
    },
    {
      icon: <ClientCardIcon3 />,
      bg: '#D9D6FF',
      label: 'Occupied IDs',
      status: 'occupied',
      value: 0
    },
    {
      icon: <PauseCircleOutlined style={{ color: '#ffc107', fontSize: '20px' }} />,
      bg: '#ffc10759',
      label: 'Paused IDs',
      status: 'paused',
      value: 0
    }
  ];
  const [billingStats, setBillingStats] = useState(billingStatData);

  const handleGetList = async (search) => {
    try {
      setLoading(true);
      let params = new URLSearchParams();
      search && params.append('search', search);
      sort?.sortBy && params.append('sortBy', sort?.sortBy);
      sort?.orderBy && params.append('sortOrder', sort?.orderBy);

      if (status !== null && status !== undefined) params.append('type', status);

      let res = await GetProjectSources(params);
      if (res?.statusCode === 200) {
        setData(res?.data?.results);
      } else {
        toast.error(res?.message || 'Something went wrong');
      }
    } catch (error) {
      toast.error(error?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    try {
      setDeleteLoading(true);

      let res = await DeleteProjectSource(editData?.id);
      if (res?.statusCode === 200) {
        toast.success('Id Deleted Successfully');
        handleGetList();
        getCardsCount();
      } else {
        toast.error(res?.message || 'Something went wrong');
      }
    } catch (error) {
      toast.error(error?.message || 'Something went wrong');
    } finally {
      setDeleteModal(false);
      setDeleteLoading(false);
      setEditData(null);
    }
  };

  const getCardsCount = async () => {
    setCardLoading(true);
    try {
      const res = await GetBillingIdCount();
      if (res?.statusCode === 200) {
        res?.data &&
          setBillingStats((prevStats) =>
            prevStats.map((item) => ({
              ...item,
              value: res?.data[item.status] ?? 0
            }))
          );
      } else {
        toast.error(res?.message || 'Something went wrong');
      }
    } catch (error) {
      toast.error(error?.message || 'Something went wrong');
    } finally {
      setCardLoading(false);
    }
  };

  const columns = [
    {
      title: 'S.NO',
      dataIndex: 'key',
      key: 'key',
      render: (_, __, i) => <span>{i + 1}.</span>
    },
    {
      title: 'Username',
      dataIndex: 'user_name',
      key: 'user_name',
      sorter: true,
      render: (name, user) => {
        const emp = [
          {
            name: name,
            src: process.env.REACT_APP_S3_BASE_URL + user?.profile_image,
            id: user?.id
          }
        ];
        return (
          <FlexWrapper justify={'start'} gap={'6px'} wrap={'unset'} cursor="default">
            <AvatarGroup avatars={emp} />
            <HighlightText
              onClick={() => {
                const formatData = {
                  ...user,
                  password: decryptToken(user?.password),
                  security_id: decryptToken(user?.security_id)
                };
                setViewData(formatData);
                setView(true);
              }}>
              {name || '-'}
            </HighlightText>
          </FlexWrapper>
        );
      }
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: true
    },
    {
      title: 'Platform',
      dataIndex: 'platform',
      key: 'platform',
      render: (val) => getBillingTag(val)
    },
    // {
    //   title: 'Email',
    //   dataIndex: 'email',
    //   key: 'email',
    //   sorter: true,
    //   render: (email) => {
    //     return (
    //       <CopyWrapper>
    //         <span>{email}</span>
    //         <CopyToClipboard valueToCopy={email} />
    //       </CopyWrapper>
    //     );
    //   }
    // },
    {
      title: 'No. of Projects',
      dataIndex: 'no_of_project',
      key: 'no_of_project',
      sorter: true,
      render: (val, data) => {
        return (
          <div
            style={{ cursor: 'pointer', fontWeight: '500' }}
            onClick={() => {
              data?.no_of_project > 0 && setProjectList(true);
              setProjectListData(data);
            }}>
            {val || 0}
          </div>
        );
      }
    },
    {
      title: 'Employee',
      dataIndex: 'employee',
      key: 'employee',
      render: (_, record) => {
        let data = record?.assigned_employees?.map((emp) => {
          return {
            name: getFullName(emp?.first_name, emp?.middle_name, emp?.last_name),
            src: generateEmployeeImgUrl(emp?.employee_id),
            id: emp?.employee_id
          };
        });

        return (
          <FlexWrapper wrap="no-wrap" justify={'start'} gap={'6px'}>
            {data?.length <= 0 ? (
              'N/A'
            ) : (
              <>
                <AvatarGroup avatars={data} />
                {data?.length === 1 && (
                  <p style={{ fontSize: '14px', margin: 0 }}>{data[0]?.name}</p>
                )}
              </>
            )}
          </FlexWrapper>
        );
      }
    },
    {
      title: 'Status',
      dataIndex: 'status',
      render: (val) => BillingStatusTag(val)
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      className: 'action-column',
      render: (_, data) => {
        return (
          <FlexWrapper justify={'start'} gap={'6px'} cursor="default" wrap={'unset'}>
            <ViewIconBox
              onClick={() => {
                const formatData = {
                  ...data,
                  password: decryptToken(data?.password),
                  security_id: decryptToken(data?.security_id)
                };
                setViewData(formatData);
                setView(true);
              }}>
              <ViewIconNew />
            </ViewIconBox>
            {canUpdate && (
              <EditIconBox
                canUpdate={canUpdate}
                onClick={() => {
                  if (canUpdate) {
                    const formatData = {
                      ...data,
                      password: decryptToken(data?.password),
                      security_id: decryptToken(data?.security_id)
                    };
                    setAddModal(true);
                    setEditData(formatData);
                  }
                }}>
                <EditIcon />
              </EditIconBox>
            )}
            {canDelete && (
              <DeleteIconBox
                canDelete={canDelete && data?.no_of_project <= 0}
                onClick={() => {
                  if (canDelete && data?.no_of_project <= 0) {
                    setDeleteModal(true);
                    setEditData(data);
                  }
                }}>
                <DeleteIcon />
              </DeleteIconBox>
            )}
          </FlexWrapper>
        );
      }
    }
  ];

  const optimizedFn = useCallback(debounce(handleGetList), [status, sort]);

  useEffect(() => {
    if (search !== null) {
      optimizedFn(search);
    } else {
      handleGetList();
    }
  }, [search, status, sort]);

  useEffect(() => {
    getCardsCount();
  }, []);

  return (
    <FlexWrapper direction="column" gap="20px" cursor="default">
      {activityDrawer && (
        <Drawer
          width={490}
          title="Activity"
          placement="right"
          closable={true}
          prefixCls="activityCustomDrawer"
          onClose={() => dispatch(updateActivityDrawer(false))}
          open={activityDrawer}
          key="right">
          <ActivityDrawer clientId={user_details?.id} />
        </Drawer>
      )}
      {projectList && projectListData?.no_of_project > 0 && (
        <ProjectsListingModal
          open={projectList}
          onClose={() => {
            setProjectList(false);
            setProjectListData([]);
          }}
          selectedId={projectListData}
        />
      )}
      <FlexWrapper
        width="100%"
        direction="column"
        cursor="default"
        gap="5px"
        justify="space-between"
        align="space-between">
        <CardWrapper>
          {billingStats?.map((item, index) => (
            <div key={item?.bg + index}>
              <ProjectCard
                image={item.icon}
                bg={item.bg}
                loading={cardLoading}
                content={
                  <div>
                    <CardContent>{item.label}</CardContent>
                    <Title style={{ margin: 0 }} level={2}>
                      <CountUp end={(item.value || 0)?.toString()?.padStart(2, '0')} />
                    </Title>
                  </div>
                }
              />
            </div>
          ))}
        </CardWrapper>
      </FlexWrapper>

      <FlexWrapper width="100%" gap="20px" cursor="default">
        {deleteModal && (
          <ConfirmationModal
            open={deleteModal}
            onCancel={() => setDeleteModal(false)}
            title={'Delete Billing ID'}
            onSubmit={handleDelete}
            buttonName={'Delete'}
            description={'Are you sure you want to delete this Billing ID?'}
            iconBG={'#FB4A49'}
            icon={<TrashIconNew />}
            loading={deleteLoading}
          />
        )}
        {addModal && (
          <AddId
            open={addModal}
            onClose={() => setAddModal(false)}
            editDetails={editData}
            handleGetList={handleGetList}
          />
        )}
        {view && <ViewBillingId open={view} onClose={() => setView(false)} viewData={viewData} />}
        <StickyBox style={{ width: '100%' }} padding="8px 0">
          <FlexWrapper
            justify={largeScreen ? 'space-between' : 'start'}
            width="100%"
            cursor="default"
            gap="10px">
            {canCreate ? (
              <Button
                type="text"
                onClick={() => {
                  setAddModal(true);
                  setEditData(null);
                }}
                prefixCls="antCustomBtn">
                + Add New ID
              </Button>
            ) : (
              <div></div>
            )}
            <FlexWrapperParent gap="10px" width={mediumScreen ? 'fit-content' : '100%'}>
              <Select
                prefixCls="antSubFilter"
                width={mediumScreen ? '150px' : '100%'}
                placeholder={`Select Status`}
                value={status}
                allowClear
                onChange={setStatus}
                options={billingIdsStatus}
              />
              <SearchField
                placeholder="Search by name or username..."
                width="250px"
                onChange={(value) => setSearch(value)}
                value={search}
                allowClear={true}
              />
            </FlexWrapperParent>
          </FlexWrapper>
        </StickyBox>

        <FlexWrapper width="100%" cursor="default">
          {loading || data.length > 0 ? (
            <>
              <Table
                prefixCls="antCustomTable"
                columns={columns}
                dataSource={data}
                pagination={false}
                loading={loading}
                onChange={(newPagination, filters, sorter) => {
                  handleSorting(sorter);
                }}
                defaultSortOrder={sort.order}
                scroll={{ x: '100%' }}
              />
            </>
          ) : (
            <FlexWrapper direction="column" gap="10px" cursor="default">
              <EmptyData
                title={'No Data'}
                subTitle={'No Billing Ids created yet kindly create first Billing Id'}
                icon={<ClientEmptyIcon />}
                height={'40vh'}
              />
            </FlexWrapper>
          )}
        </FlexWrapper>
      </FlexWrapper>
    </FlexWrapper>
  );
};

export default BillingIds;

const Tag = styled.div`
  height: 30px;
  border-radius: 100px;
  border: 1px solid transparent;
  background-color: ${({ bg }) => bg};
  color: ${({ color }) => color};
  display: flex;
  align-items: center;
  padding: 0 15px;
  justify-content: center;
  width: fit-content;
  white-space: nowrap;
`;
const FlexWrapperParent = styled.div`
  width: ${(props) => props.width};
  display: flex;
  flex-wrap: ${(props) => props.wrap || 'nowrap'};
  flex-direction: ${(props) => props.direction || 'row'};
  justify-content: ${(props) => props.justify || 'center'};
  align-items: ${(props) => props.align || 'center'};
  gap: ${(props) => props.gap || '10px'};
  cursor: ${(props) => props.cursor || 'auto'};
  margin: ${(props) => props.margin || '0px'};

  @media (max-width: 768px) {
    width: 100%;
    flex-wrap: wrap;
    justify-content: start;
    .antSubFilter {
      width: 100% !important;
    }
  }

  @media (max-width: 568px) {
    width: 100%;
    align-items: start;
    justify-content: start;
    flex-direction: column;
  }
`;
const CardWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 968px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 5px;
  }
`;
